// the starting point for your redux store
// this defines what your store state will look like
import { combineReducers } from 'redux';

import BooksReducer from './books-reducer';
import AuthReducer from './auth-reducer';
import ChaptersReducer from './chapters-reducer';
import PagesReducer from './pages-reducer';
import linkReducer from './link-reducer';
import NotebookReducer from './notebook-reducer';
import PersonalNotesReducer from './personalNotes-reducer';
import ContributorsReducer from './contributors-reducer';
import AuthorReducer from './author-reducer';
import UserReducer from './user-reducer';
import ReactionsReducer from './reactions-reducer';
import UserPagesReducer from './user-pages-reducer';
import CommentsReducer from './comments-reducer';

const rootReducer = combineReducers({
  books: BooksReducer,
  chapters: ChaptersReducer,
  pages: PagesReducer,
  auth: AuthReducer,
  notebook: NotebookReducer,
  personalNotes: PersonalNotesReducer,
  link: linkReducer,
  contributors: ContributorsReducer,
  author: AuthorReducer,
  user: UserReducer,
  reactions: ReactionsReducer,
  comments: CommentsReducer,
  userPages: UserPagesReducer,
});

export default rootReducer;
